import script from "./VTLaser.vue?vue&type=script&lang=js"
export * from "./VTLaser.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__